import styled from "styled-components";
import { fHeader, fHeaderSm, fBodySm } from "../../styles/global";

export const Title = styled.h1`
  ${fHeader}
  margin-bottom: 4.6rem;
`;

export const Post = styled.article`
  & + article {
    margin-top: 4.6rem;
  }
`;

export const PostTitle = styled.h1`
  ${fHeaderSm}
`;

export const PostText = styled.div`
  border-top: 1px solid black;
  padding-top: 1.3rem;
  @media (max-width: 570px) {
    border-top: none;
  }
`;

export const PostDate = styled.span`
  ${fBodySm}
`;

export const ColumnsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 570px) {
    flex-direction: column;
    border-top: 1px solid black;
    padding-top: 1.3rem;
  }
`;

export const Left = styled.div`
  flex: 1;
  margin-right: 4.6rem;
  @media (max-width: 570px) {
    margin-right: 0;
    order: 2;
  }
`;

export const Right = styled.div`
  flex: 2;
  @media (max-width: 1023px) {
    flex: 1;
  }
  @media (max-width: 570px) {
    order: 1;
  }
`;
